export default __webpack_public_path__ + "static/media/jap-ecommerceImg_4.e12597e8.png";